import { render } from "./VF-menu.vue?vue&type=template&id=5e3919ce&scoped=true"
import script from "./VF-menu.vue?vue&type=script&lang=js"
export * from "./VF-menu.vue?vue&type=script&lang=js"

import "./VF-menu.vue?vue&type=style&index=0&id=5e3919ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3919ce"]])

export default __exports__